import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import cert from './images/cert.jpeg';
import Model from '../../../model';
import './index.sass';

const { block, el } = bem('give-cert-widget');
const GiveCertWidget = () => {
    const { isKZ } = Model.kz;

    if (isKZ) return null;

    return (
        <Link className={block()} to={'/certificates'}>
            <div className={el('photo')}>
                <TeaserPhoto img={cert} />
            </div>
            <div className={el('bottom-block')}>
                <div className={el('text')}>
                    <Text serif>Подарите сертификат родному человеку</Text>
                </div>
                <div className={el('icon')}>
                    <Icon name={'caret-right'} />
                </div>
            </div>
        </Link>
    )
}

export default GiveCertWidget;
